import { render } from "./GlobalSeacrhPanel.vue?vue&type=template&id=2fefe27d"
import script from "./GlobalSeacrhPanel.vue?vue&type=script&lang=js"
export * from "./GlobalSeacrhPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__